<template>
      <el-carousel indicator-position="outside" :autoplay="true"  @change="changeSwiper">
        <!-- <el-carousel-item> -->
          <el-carousel-item v-for="(item, index) in swiperItems" :key="index">
            <div class="index_swiper">
              <div class="swiper_container">
                <div class="left_image left_layout">
                  <div class="layout_con"> 
                    <!-- <img :alt="item[10].carousel.alt" :src=" item[10] ? item[10].carousel.url : require('../../../assets/image/12.数字孪生+.png')"> -->
                    <img src="../../../assets/image/12.数字孪生+.png">
                    <!-- <p class="layout_p1 layout_p1_margin">{{ index }}</p> -->
                    <p class="layout_p1 layout_p1_margin">{{ item[0].first_layout_p1 ? item[0].first_layout_p1 : 'Digital Twins +' }}</p>
                    <p class="layout_p2 layout_p2_margin">{{ item[1].first_layout_p2 ? item[1].first_layout_p2 : '数字孪生+' }}</p>
                  </div>
                  <div class="layout_con">
                    <img src="../../../assets/image/13.PONGO下载icon.png">
                    <p class="layout_p1 layout_p1_margin">{{ item[6].second_layout_p1 ? item[6].second_layout_p1 : 'PONGO Download' }}</p>
                    <p class="layout_p2 layout_p2_margin">{{ item[7] ? item[7].second_layout_p2 : 'PONGO下载' }}</p>
                  </div>
                  <div class="layout_con">
                    <img src="../../../assets/image/14.模型库icon.png">
                    <!-- <p class="layout_p1 layout_p1_margin">{{ item[8]}}</p> -->
                    <p class="layout_p1 layout_p1_margin">{{ item[8] ? item[8].third_layout_p1 : 'Model Library' }}</p>
                    <p class="layout_p2 layout_p2_margin">{{ item[9] ? item[9].third_layout_p2 : '模型库'}}</p>
                  </div>
                </div>
                <div class="right_title">
                  <!-- <p class="title1">矢量</p> -->
                  <p class="title1 title1_margin">{{ item[2].line1_title1 ? item[2].line1_title1 : '矢量' }}</p>
                  <p class="title1 title1_margin">{{ item[4].line2_title1 ? item[4].line2_title1 : '构筑企业数字化新生态' }}</p>
                  <p class="title2 title2_margin">{{ item[3].line1_title2 ? item[3].line1_title2 : '以自研数字孪生平台PONGO为核心，为企业提供全生命周期的数字化' }}</p>
                  <p class="title2">{{ item[5].line2_title2 ? item[5].line2_title2 : '应用解决方案，助力企业在数字化时代的转型升级' }}</p>
                  <!-- <p class="detail">
                    <span>查看详情</span>
                    <img src="../../../assets/image/15.查看详情.png" style="margin-left: 1%; cursor: pointer;"></p> -->
                </div>
              </div>
            </div>
        </el-carousel-item>
      </el-carousel>
  </template>

  <script>
  import { getBanner, getImg } from '../../../util/index'
  export default {
    name:'IndexSwiper',
    data() {
      return {
        swiperItems: ['Slide 1', 'Slide 2', 'Slide 3', 'Slide 4', 'Slide 5'],
        swiperInstance: null,
      };
    },
    props:{
      isIndex:Boolean
    },
    methods:{
      changeSwiper(index){
        let total = this.swiperItems.length
        let pagesInfo = {
          total,
          index: index+1
        }
        this.$emit('totalPages', pagesInfo)
      }
    },
    mounted() {
      let page = '首页', category = '轮播图'
      getBanner(page, category).then(res=>{
        if(res.code === 200){
          let data = res.data
          // 创建一个对象来存储分组
          const groupedData = {};

          // 遍历每一个键值对，将 `-` 前面的部分作为键，后面的部分放入数组
          Object.keys(data).forEach(key => {
              const [prefix, suffix] = key.split('-'); // 分割前缀和后缀
              if (!groupedData[prefix]) {
                  groupedData[prefix] = []; // 初始化数组
              }
              groupedData[prefix].push({ [suffix]: data[key] }); // 添加后缀和对应值
          });

          // 对每个数组的对象按键排序
          const sortedData = Object.values(groupedData).map(group => {
              return group.sort((a, b) => {
                  const aKey = Object.keys(a)[0]; // 获取对象的键
                  const bKey = Object.keys(b)[0];
                  return aKey.localeCompare(bKey); // 按字母顺序比较
              });
          });
          // console.log(sortedData);
          this.swiperItems = sortedData
        }
      }).then(()=>{
        let str = '首页-轮播图'
        getImg(str).then(res=>{
          if(res.code === 200){
            let data = res.data
            // 遍历对象
            Object.keys(data).forEach((key, index) => {
              // console.log(this.swiperItems[index]);
              this.swiperItems[index].push({
                carousel : data[key]
              })
            })

          }
        })
      })
      
    },
  };
  </script>

  <style scoped lang="less">
  ::v-deep .el-carousel__container{
    height: 95vh;
  }
  ::v-deep .el-carousel__indicators--outside{
    position: absolute;
    left: 45%;
  }
  ::v-deep .el-carousel__indicator--horizontal{
    padding: 0.5rem 0.75rem;
  }
  ::v-deep .el-carousel__indicator.is-active button{
    background-color: #54d1ef;
  }
  ::v-deep .el-carousel__button{
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
  .el-carousel__item h3 {
    color: #ffffff;
    font-size: 18px;
    opacity: 0.75;
    line-height: 500px;
    margin: 0;
  }
  .index_swiper{
    background-image: url("../../../assets/image/资源\ 173.png");
    background-size: cover;
    height: 100%;
    display: flex;
    align-items: center;
    // justify-content: center;
  }
  .swiper_container{
    width: 80%;
    display: flex;
    margin: 0 auto;
    padding-bottom: 5rem;
    .left_image, .right_title{
      color: #ffffff;
    }
    .left_layout{
      display: flex;
      width: 50%;
      // margin-right: 5%;
      .layout_con{
        margin-right: 20px;
        width: 25%;
      }
      .layout_p1{
        font-size: 0.75rem;
        color: #999999;
      }
      .layout_p1_margin{
        margin-top: 15%;
        font-family: AliLight;
        color: #969696;
        font-size: 0.9rem;
      }
      .layout_p2{
        font-size: 1rem;
        color: #fff;
        font-family: AliRegular;
      }
      .layout_p2_margin{
        margin-top: 5%;
      }
    }
    .right_title>.title1{
      color: #54ceec;
      font-family: AliBold;
      font-size:3.6rem;
      // letter-spacing: 0.5rem;
      // line-height: 1.1;
    }
    // .right_title>.title1_margin{
    //   margin-top: 5%;
    // }
    .right_title>.title2{
      font-size: 0.9rem;
      color: #dadada;
      letter-spacing: 0.1rem;
      line-height: 1.8;
    }
    .right_title>.title2_margin{
      margin-top: 3%;
    }
    .right_title>.detail{
      font-size: 0.75rem;
      margin: 6% 0 0 0;
      color: #999999;
      cursor: pointer;
    }
    .right_title>img{
      margin-left: 1%;
    }
  }
  </style>